import { render, staticRenderFns } from "./OnumberCard.vue?vue&type=template&id=3dd398e4&"
import script from "./OnumberCard.vue?vue&type=script&lang=js&"
export * from "./OnumberCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports